import { actionTypes } from './constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from './api';
import * as T from './types';

export const fetchWidgetData = createAsyncThunk(
  actionTypes.FETCH_WIDGET_DATA,
  async ({ siteId, widgetId }: T.FetchWidgetApiPayload) =>
    await api.fetchWidgetDataApi({
      siteId,
      widgetId,
    })
);
